/*
 * @flow strict
 * Copyright (C) 2019 MetaBrainz Foundation
 *
 * This file is part of MusicBrainz, the open internet music database,
 * and is licensed under the GPL version 2, or (at your option) any
 * later version: http://www.gnu.org/licenses/gpl-2.0.txt
 */

function localizeInstrumentName(instrument: InstrumentT): string {
  if (instrument.comment) {
    return lp_instruments(instrument.name, instrument.comment);
  }
  return l_instruments(instrument.name);
}

export default localizeInstrumentName;
